var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "body-1 mb-3",
              attrs: {
                role: "heading",
                "aria-level": "2"
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "pb-1",
                  attrs: {
                    size: "24",
                    color: "error",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-backup-restore")]
              ),
              _c(
                "span",
                {
                  staticClass: "ml-2"
                },
                [_vm._v("Rebuild Server")]
              )
            ],
            1
          ),
          _c(
            "v-alert",
            {
              staticClass: "kvm-rebuild__warning mb-4",
              attrs: {
                type: "warning",
                border: "left",
                dense: ""
              }
            },
            [
              _vm._v(" Rebuilding "),
              _c("strong", [
                _vm._v("destroys this server's disk and everything on it")
              ]),
              _vm._v(
                ", then installs a fresh operating system or application. Your IP address and region are kept. This cannot be undone. "
              )
            ]
          ),
          _vm.loadingCatalog
            ? _c(
                "div",
                {
                  staticClass: "py-6 text-center"
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: "32",
                      width: "3",
                      "aria-label": "Loading install options"
                    }
                  })
                ],
                1
              )
            : [
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 mb-2",
                    attrs: {
                      id: "kvm-rebuild-what"
                    }
                  },
                  [_vm._v("What to install")]
                ),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-0 mb-3",
                    attrs: {
                      "hide-details": "",
                      "aria-labelledby": "kvm-rebuild-what"
                    },
                    model: {
                      value: _vm.mode,
                      callback: function callback($$v) {
                        _vm.mode = $$v
                      },
                      expression: "mode"
                    }
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        value: "same"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function fn() {
                            return [
                              _c("span", [_vm._v("Reinstall the current OS")]),
                              _c(
                                "span",
                                {
                                  staticClass: "kvm-secondary ml-1"
                                },
                                [_vm._v("(" + _vm._s(_vm.server.os) + ")")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _c("v-radio", {
                      attrs: {
                        value: "choose",
                        label: "Install a different OS or application"
                      }
                    })
                  ],
                  1
                ),
                _vm.mode === "choose"
                  ? _c("kvm-catalog-picker", {
                      staticClass: "mb-2",
                      attrs: {
                        "operating-systems": _vm.catalog.operating_systems,
                        apps: _vm.catalog.apps,
                        "confirm-label": "Use this"
                      },
                      model: {
                        value: _vm.selection,
                        callback: function callback($$v) {
                          _vm.selection = $$v
                        },
                        expression: "selection"
                      }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 mb-2 mt-2",
                    attrs: {
                      id: "kvm-rebuild-domain"
                    }
                  },
                  [
                    _vm._v(" Domain "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-secondary"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.domainRequired
                              ? "(required for app installs)"
                              : "(optional)"
                          )
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-start",
                    staticStyle: {
                      "max-width": "560px"
                    }
                  },
                  [
                    _c("v-text-field", {
                      staticClass: "mr-2",
                      attrs: {
                        placeholder: "app.example.com",
                        outlined: "",
                        dense: "",
                        "persistent-hint": "",
                        hint: _vm.domainHint,
                        error: _vm.domainRequired && !_vm.domainInput.trim(),
                        "aria-labelledby": "kvm-rebuild-domain"
                      },
                      model: {
                        value: _vm.domainInput,
                        callback: function callback($$v) {
                          _vm.domainInput = $$v
                        },
                        expression: "domainInput"
                      }
                    }),
                    _vm.suggestedDomain
                      ? _c(
                          "gg-btn",
                          {
                            staticClass: "mt-1 kvm-aa-text",
                            attrs: {
                              small: "",
                              tile: "",
                              outlined: "",
                              color: "primary",
                              "aria-label": "Generate a free subdomain"
                            },
                            on: {
                              click: _vm.generateDomain
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  left: "",
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-auto-fix")]
                            ),
                            _vm._v("Generate ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("kvm-domain-check", {
                  staticClass: "mt-1 mb-2",
                  attrs: {
                    "entitlement-id": _vm.server.id,
                    domain: _vm.domainInput
                  }
                }),
                _c("v-divider", {
                  staticClass: "mt-2 mb-3"
                }),
                _c("kvm-ssh-keys", {
                  staticClass: "mb-4",
                  attrs: {
                    "entitlement-id": _vm.server.id,
                    selectable: ""
                  },
                  model: {
                    value: _vm.sshKeyIds,
                    callback: function callback($$v) {
                      _vm.sshKeyIds = $$v
                    },
                    expression: "sshKeyIds"
                  }
                }),
                _c(
                  "gg-btn",
                  {
                    staticClass: "kvm-danger-btn mt-2",
                    attrs: {
                      color: "error",
                      disabled: !_vm.canRebuild,
                      "aria-label": "Rebuild server"
                    },
                    on: {
                      click: function click($event) {
                        _vm.confirmDialog = true
                      }
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-backup-restore")]
                    ),
                    _vm._v("Rebuild server ")
                  ],
                  1
                )
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "480",
                persistent: ""
              },
              model: {
                value: _vm.confirmDialog,
                callback: function callback($$v) {
                  _vm.confirmDialog = $$v
                },
                expression: "confirmDialog"
              }
            },
            [
              _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-rebuild-confirm-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-2",
                          attrs: {
                            id: "kvm-rebuild-confirm-title",
                            role: "heading",
                            "aria-level": "2"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                color: "error",
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-alert")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ml-1"
                            },
                            [_vm._v("Confirm rebuild")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mb-3"
                        },
                        [
                          _vm._v(" This permanently erases all data on "),
                          _c("strong", [_vm._v(_vm._s(_vm.server.hostname))]),
                          _vm._v(" and reinstalls it. To continue, type "),
                          _c("strong", [_vm._v("REBUILD")]),
                          _vm._v(" below. ")
                        ]
                      ),
                      _c("v-text-field", {
                        staticClass: "mb-4",
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          placeholder: "REBUILD",
                          "aria-label": "Type REBUILD to confirm",
                          autofocus: ""
                        },
                        on: {
                          keyup: function keyup($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.confirmText === "REBUILD" && _vm.rebuild()
                          }
                        },
                        model: {
                          value: _vm.confirmText,
                          callback: function callback($$v) {
                            _vm.confirmText = $$v
                          },
                          expression: "confirmText"
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2 kvm-aa-text",
                              attrs: {
                                text: "",
                                disabled: _vm.submitting
                              },
                              on: {
                                click: _vm.closeConfirm
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "kvm-danger-btn",
                              attrs: {
                                color: "error",
                                loading: _vm.submitting,
                                disabled: _vm.confirmText !== "REBUILD",
                                "aria-label": "Rebuild now"
                              },
                              on: {
                                click: _vm.rebuild
                              }
                            },
                            [_vm._v(" Rebuild now ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "kvm-sr-only",
                          attrs: {
                            "aria-live": "assertive"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.submitting ? "Starting rebuild." : "")
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }